const appendixList = [
    {
        url: "https://www.soumu.go.jp/main_sosiki/joho_tsusin/top/tel_number/shigai_list.html",
        title: "総務省｜電気通信番号制度｜市外局番の一覧",
    },
    {
        url: "https://www.ntt-east.co.jp/info-st/mutial/suburbs/numlist/",
        title: "単位料金区域別市外局番等一覧表（最新情報） | 公開情報 | 企業情報 | NTT東日本",
    },
    {
        url: "https://www.ntt-west.co.jp/open/tani_ryoukin_0509/areapay2.html",
        title: "ＮＴＴ西日本｜公開情報＞単位料金区域別市外局番等一覧表（05X～09X）",
    },
    {
        url: "https://www.ntt-east.co.jp/tariff/",
        title: "契約約款集 | 公開情報 | 企業情報 | NTT東日本",
        note: "内、単位料金区域(MA)一覧表"
    },
    {
        url: "https://www.soumu.go.jp/main_sosiki/joho_tsusin/top/tel_number/number_shitei.html",
        title: "総務省｜電気通信番号制度｜電気通信番号指定状況　（電気通信番号計画（令和元年総務省告示第6号）第1第4項による公表）",
    },
    {
        url: "https://store.chirijin.com/items/23922644",
        title: "【現実】市外局番地図ポスター（地理人 作） | 空想地図STORE ─空想地図と地図グッズ─",
    },
    {
        url: "https://www.e-stat.go.jp/municipalities/cities/areacode",
        title: "市区町村を探す | 政府統計の総合窓口",
    },
]

export default appendixList